import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import clsx from "clsx";
import {CountryData} from "react-phone-input-2";

interface PhoneInputWhiteProps {
    value: string;
    onChange: (phone: string, dialCode: string) => void;
    hasError?: boolean;
    disabled?: boolean;
    id?: string;
}

const PhoneInputWhite = ({value, onChange, hasError = false, disabled = false, id}: PhoneInputWhiteProps) => {
    return (
        <PhoneInput
            inputProps={{id, name: id}}
            country="ie"
            value={value}
            onChange={(phone, country: CountryData) => onChange(phone, country.dialCode)}
            disabled={disabled}
            enableSearch
            countryCodeEditable={false}
            containerClass={clsx("phone-input-white", hasError && "is-invalid")}
            inputClass="phone-input-white__input"
            buttonClass="phone-input-white__button"
            dropdownClass="phone-input-white__dropdown"
            searchClass="phone-input-white__search"
            placeholder="Enter your phone number"
        />
    );
};

export default PhoneInputWhite;
